import { createReducer, on } from '@ngrx/store';
import { oncoriskActions } from './oncorisk.action';
import { oncoriskState } from './oncorisk.state';

export const oncoriskReducer = createReducer(
  oncoriskState,
  on(oncoriskActions.setElevatedTraits, (state, { elevatedTraits }) => ({
    ...state,
    elevatedTraits
  })),
  on(oncoriskActions.setID, (state, { id }) => ({
    ...state,
    id
  })),
  on(
    oncoriskActions.setScoreTypeGuidelines,
    (state, { scoreTypeGuidelines }) => ({
      ...state,
      scoreTypeGuidelines
    })
  ),
  on(oncoriskActions.setCategories, (state, { categories }) => ({
    ...state,
    categories
  })),
  on(oncoriskActions.setSelectedCategory, (state, { selectedCategory }) => ({
    ...state,
    selectedCategory
  }))
);
